export const enum StorageKey {
  WORKSPACE = 'workspace',
  // keep WORKSPACE_INACTIVE value 'final-exhausted' for backward compatibility
  WORKSPACE_INACTIVE = 'final-exhausted',
  PROGRESS = 'history',
  STATS = 'stats',
  ENCYCLOPEDIA = 'encyclopedia',
  SETTINGS = 'settings',
  RESET_TIMESTAMP = 'timestamp',
  TUTORIALS = 'tutorials',
}
